module.exports = __webpack_public_path__ + "fonts/Disclaimer-Classic-2.7886f293.otf";